<template>
    <div
        v-if="isVisible"
        class="initial-message"
        :style="{ backgroundColor: backgroundColor }"
    >
        <button class="initial-message__close" @click="onClose">
            {{ isCount ? count : 'X' }}
        </button>

        <div class="initial-message__content">
            <div class="initial-message__html" v-html="centeredMessage"></div>
        </div>
    </div>
</template>

<script>
const SHOWN_DATE_KEY = 'initialMessageShownDate';

export default {
    name: 'MensajeInicial',
    data() {
        return {
            count: 5,
            timer: null,
            isCount: true,
            isVisible: false,
            currentMessage: '',
        }
    },
    computed: {
        message() {
            const configuration = this.$store.state.configuration;

            if (configuration != null && configuration.configuration != null) {
                return configuration.configuration.mensaje || '';
            }

            return '';
        },
        centeredMessage() {
            return `<div style="text-align:center;">${this.currentMessage}</div>`;
        },
        backgroundColor() {
            return this.getBackgroundColor(this.currentMessage);
        },
    },
    watch: {
        message: {
            immediate: true,
            handler(value) {
                this.tryShowMessage(value);
            }
        }
    },
    methods: {
        tryShowMessage(message) {
            if (this.isVisible || message == null || message.trim() === '') {
                return;
            }

            const today = this.getTodayKey();
            const shownDate = localStorage.getItem(SHOWN_DATE_KEY);

            if (shownDate === today) {
                return;
            }

            localStorage.setItem(SHOWN_DATE_KEY, today);
            this.currentMessage = message;
            this.isVisible = true;
            this.startTimer();
        },
        startTimer() {
            this.clearTimer();
            this.count = 5;
            this.isCount = true;

            this.timer = setInterval(() => {
                this.count -= 1;

                if (this.count <= 0) {
                    this.clearTimer();
                    this.isCount = false;
                }
            }, 1000);
        },
        onClose() {
            if (this.isCount) {
                return;
            }

            this.isVisible = false;
        },
        clearTimer() {
            if (this.timer != null) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        getTodayKey() {
            const now = new Date();
            return `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
        },
        getBackgroundColor(html) {
            const match = html.match(/background(?:-color)?\s*:\s*([^;"}]+)/i);

            if (match == null || match[1] == null) {
                return '#ffffff';
            }

            const value = match[1].trim();
            const testElement = document.createElement('span');
            testElement.style.backgroundColor = value;

            return testElement.style.backgroundColor || '#ffffff';
        },
    },
    beforeDestroy() {
        this.clearTimer();
    },
}
</script>

<style scoped>
.initial-message {
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 999999;
    display: flex;
    position: fixed;
    overflow: auto;
    align-items: center;
    justify-content: center;
}

.initial-message__content {
    width: 100%;
    padding: 80px 24px 32px;
    display: flex;
    justify-content: center;
}

.initial-message__html {
    width: 100%;
    max-width: 900px;
    text-align: center;
}

.initial-message__close {
    top: 20px;
    right: 20px;
    width: 46px;
    height: 46px;
    border: 0;
    z-index: 1;
    color: #ffffff;
    cursor: pointer;
    font-size: 20px;
    font-weight: bold;
    position: absolute;
    border-radius: 50%;
    background: #cc9933;
}
</style>
